<template>
  <div class="form-group" :class="{ 'form-group--error': field.$error }">
    <label :for="id" :class="labelClass">{{ label }}</label>
    <slot></slot>

    <form-validation-invalid-feedback :field="field" :text="text" />
  </div>
</template>

<script>
import FormValidationInvalidFeedback from '@/core/components/FormValidationInvalidFeedback'

export default {
  name: 'FormGroup',
  components: { FormValidationInvalidFeedback },
  props: {
    field: { type: Object, required: true },
    text: [Object, String],
    label: String,
    id: String,
    labelClass: String
  }
}
</script>

<style scoped lang="sass">
  .invalid-feedback
    display: block

  .form-group--error

    label
      color: #dc3545

    input, textarea, select
      border-color: #dc3545

    animation:
      name: shakeError
      fill-mode: forwards
      duration: .6s
      timing-function: ease-in-out

    @keyframes shakeError
      0%
        transform: translateX(0)

      15%
        transform: translateX(6px)

      30%
        transform: translateX(-6px)

      45%
        transform: translateX(6px)

      60%
        transform: translateX(-6px)

      75%
        transform: translateX(6px)

      90%
        transform: translateX(-6px)

      100%
        transform: translateX(0)
</style>
